import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    year: '',
    institucion: '',
    noContrato: '',
    company: '',
}

export const dataSlice = createSlice({
    name: 'data',
    initialState: initialState,
    reducers: {
        setNoContrato: (state, action) => {
            state.noContrato = action.payload;
        }
    }
})

export const { setNoContrato } = dataSlice.actions;

export default dataSlice.reducer;